import { useState, FormEvent, useEffect } from 'react';
import { useMonitorStore } from '../lib/monitorStore';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const { setAuth } = useMonitorStore();

  // Check for token in URL (from magic link redirect)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const emailParam = params.get('email');
    if (token && emailParam) {
      setAuth(token, emailParam);
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [setAuth]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!email) {
      setError('Please enter your email');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://api.caldera.homes/auth/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, redirect_to: 'monitor' }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Failed to send magic link');
        return;
      }

      setSuccess(true);
    } catch (e) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Caldera Monitor</h1>
        <p>Real-time relay session visualization</p>

        {success ? (
          <div className="login-success">
            Check your email for the magic link to sign in.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              autoFocus
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send Magic Link'}
            </button>
            {error && <div className="login-error">{error}</div>}
          </form>
        )}
      </div>
    </div>
  );
}
